<template>
    <div >

        <div class="panel panel-success" >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU CONTRATO
            </div>
            <!-- List group -->
            <ul class="list-group" v-if="contrato && contrato._id">

                <li class="list-group-item" >
                    <a :href="'#/contrato/add/' + contrato._id">EDITAR DADOS</a>
                </li>

                <li class="list-group-item" v-if="user.permissoes.cacontrol">
                    <a :href="'#/contrato/cacontrol/' + contrato._id " >FINANCEIRO</a>
                </li>

                <li class="list-group-item" v-if="user.level <= 5">
                    <a :href="'#/contrato/hotspots/' + contrato._id" >HOTSPOT</a>
                </li>

                <li class="list-group-item">
                    <a :href="'#/contrato/atendimentos/' + contrato._id" >ATENDIMENTOS</a>
                </li>

            </ul>
            <ul class="list-group" v-if="!contrato || !contrato._id">
                <li class="list-group-item" >
                    <a :href="'#/mapa-geral'">MAPA GERAL</a>
                </li>
            </ul>

        </div>

        <div class="panel panel-warning" v-if="contrato && user.permissoes.financeiro" >

            <!-- Default panel contents -->
            <div class="panel-heading">FINANCEIRO</div>
            <!-- List group -->
            <ul class="list-group" v-if="contrato._id">

                <li class="list-group-item" >
                    <a :href="'#/contrato/financeiro/' + contrato._id " >DADOS BÁSICOS</a>
                </li>

                <li class="list-group-item" >
                    <a :href="'#/contrato/boleto/' + contrato._id " >NOVO BOLETO AVULSO</a>
                </li>
            </ul>

        </div>

        <div v-if="contrato">
            <a :href="'#/contrato/onu/' + contrato._id " v-if="contrato.tipo === 'FIBRA' && contrato._id && contrato.caixa_pacpon"
               class="btn btn-warning hidden-xs hidden-sm btn-block">
                <i class="fa fa-search-minus" aria-hidden="true"></i> CONSULTAR CAIXA
            </a><br/>

            <a :href="'#/atendimento/novo/' + contrato._id" class="btn btn-info hidden-xs hidden-sm btn-block">
                <i class="fa fa-external-link-square-alt" aria-hidden="true"></i> NOVO ATENDIMENTO
            </a><br/>
        </div>

        <div class="panel panel-danger" v-if="contrato && user.permissoes.comandos && contrato._id" >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-terminal" aria-hidden="true"></i> COMANDOS
            </div>
            <!-- List group -->
            <ul class="list-group">

                <li class="list-group-item" v-if="user.level <= 5 && contrato.tipo === 'RADIO'">
                    <router-link :to="{ path: '/contrato/comandos/' + contrato._id}">COMANDOS</router-link>
                </li>
                <li class="list-group-item" v-if="(user.level <= 5 || user.level === 100) && contrato.tipo === 'RADIO'">
                    <a :href="'#/contrato/portas/' + contrato._id" >PORTAS</a>
                </li>
                <li class="list-group-item" v-if="user.level <= 5 && contrato.tipo === 'RADIO'">
                    <a :href="'#/contrato/traceroute/' + contrato._id" >TRACEROUTE</a>
                </li>
                <li class="list-group-item" v-if="user.level <= 5">
                    <a :href="'#/contrato/logs/' + contrato._id" >LOGS</a>
                </li>
                <li class="list-group-item" v-if="user.level <= 5">
                    <a :href="'#/contrato/usuarios/' + contrato._id" >USUÁRIOS</a>
                </li>

            </ul>
        </div>

        <button type="button" v-if="contrato"
                @click="desconectar()" class="btn btn-danger hidden-xs hidden-sm btn-block">
            <i class="fa fa-thumbs-down" aria-hidden="true"></i> DESCONECTAR <span v-if="contrato.tipo === 'RADIO'">RÁDIO</span> <span v-else>ROTEADOR</span>
        </button>

        <button type="button" @click="reboot()" v-if="contrato && contrato.tipo === 'RADIO'"
                class="btn btn-warning hidden-xs hidden-sm btn-block">
            <i class="fa fa-retweet" aria-hidden="true"></i> REBOOT NO RADIO
        </button>

        <button type="button" v-if="contrato" @click="ping()"
                class="btn btn-success hidden-xs hidden-sm btn-block">
            <i class="fa fa-chevron-right" aria-hidden="true"></i> CHECAR CLIENTE - 'PING'
        </button>

    </div>
</template>
<script>
/* eslint-disable no-undef */

import { Contratos } from "../class/contratos";
export default {
    props: {
        contrato: {
            default: () => {}
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        desconectar() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Desconectar",
                    text: "Posso desconectar o radio?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.desconectar(this.contrato._id)
                                .then(() => {
                                    this.$parent.$emit("comandos");
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        ping() {
            Contratos.ping(this.contrato._id)
                .then(() =>
                    swal("Roteador ONLINE!", "Roteador pingando!", "success")
                )
                .catch(() =>
                    swal("Roteador OFFLINE!", "Roteador não pinga!", "error")
                );
        },
        reboot() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Reiniciar",
                    text: "Posso reiniciar o roteador?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.reboot(this.contrato._id)
                                .then(() => resolve())
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
